import { Button } from "components/DesignSystem/Button/Button";
import { Checkbox } from "components/DesignSystem/Checkbox/Checkbox";
import { Label } from "components/DesignSystem/TextInput/TextInput";
import { EditPencil } from "components/icons/EditPencil";
import { useModal } from "hooks/useModal";
import { useTypedFormikContext } from "hooks/useTypedFormikContext";
import { ExportSectionsModal } from "pages/Books/FinancialsSummary/CustomizeSectionsPanel";
import { SECTION_GROUPS, SectionKey } from "constants/financialSummary";
import { ExportFormValues } from "types/Models/consolidatedReport";

const SelectedSectionsDescription = ({
  sections,
}: {
  sections: Record<SectionKey, boolean>;
}) => {
  const allSectionLabels = SECTION_GROUPS.flatMap((g) => g.sections);
  const selectedLabels = allSectionLabels
    .filter((s) => sections[s.key])
    .map((s) => s.label);

  const MAX_VISIBLE = 3;
  const visible = selectedLabels.slice(0, MAX_VISIBLE);
  const remaining = selectedLabels.length - MAX_VISIBLE;
  let description = visible.join(", ");
  if (remaining > 0) description += ` +${remaining} more`;

  return (
    <span className="t-text-body-sm t-italic t-text-text-30">
      {description || "No sections selected"}
    </span>
  );
};

export const IncludeFinancialSummary = () => {
  const { values, setFieldValue } = useTypedFormikContext<ExportFormValues>();
  const sectionsModal = useModal();

  return (
    <div>
      <Label>Content:</Label>
      <div className="t-flex t-items-center t-gap-3">
        <Checkbox
          name="includeFinancialSummary"
          checked={values.includeFinancialSummary}
          onChange={() =>
            setFieldValue(
              "includeFinancialSummary",
              !values.includeFinancialSummary
            )
          }
          label=""
        />
        <div className="t-flex t-items-center t-justify-between t-flex-1 t-py-3 t-px-4 t-border t-border-solid t-border-neutral-10 t-rounded">
          <div className="t-flex t-flex-col t-gap-0.5">
            <span className="t-text-subtext t-text-text-100">
              Include Financial Summary
            </span>
            <SelectedSectionsDescription
              sections={
                values.financialSummarySections as Record<SectionKey, boolean>
              }
            />
          </div>
          {values.includeFinancialSummary && (
            <Button
              customType="ghost_icon"
              size="small"
              onClick={sectionsModal.open}
            >
              <EditPencil />
            </Button>
          )}
        </div>
      </div>
      <ExportSectionsModal
        open={sectionsModal.isOpen}
        onClose={sectionsModal.close}
        visibleSections={values.financialSummarySections}
        groupOrder={values.financialSummaryGroupOrder}
        analysisTypes={values.financialSummaryAnalysisTypes}
        onExport={(sections, analysisTypes) => {
          setFieldValue("financialSummarySections", sections);
          setFieldValue("financialSummaryAnalysisTypes", analysisTypes);
          sectionsModal.close();
        }}
      />
    </div>
  );
};
